import { Validator } from "./types";
import { SearchContextType } from "../search-context";
import ValidationErrorMessages from "./error-messages";

const validatePhoneSearch: Validator = (data: SearchContextType) => {
  const { telNo, mobileTelNo, firstName, middleNames, lastName, dateOfBirth } =
    data;

  const hasTel = !!telNo?.trim();
  const hasMobile = !!mobileTelNo?.trim();
  const hasAnyOtherValue =
    !!firstName?.trim() ||
    !!middleNames?.trim() ||
    !!lastName?.trim() ||
    !!dateOfBirth?.toString().trim();

  const onlyPhonePresent = (hasTel || hasMobile) && !hasAnyOtherValue;

  if (!(hasTel || hasMobile)) {
    return { isValid: false, errors: [] };
  }

  return onlyPhonePresent
    ? { isValid: true, errors: [] }
    : { isValid: false, errors: [ValidationErrorMessages.invalidPhone] };
};

export default validatePhoneSearch;
